import { withDependencies } from '@wix/thunderbolt-ioc/dist'
import { ExternalComponentDsPublicApiSymbol } from 'feature-external-component'
import type { IExternalComponentDsPublicApi } from 'feature-external-component'
import { FileChangedMiddleware } from '../types'

export const ExternalComponentFileChangedMiddleware = withDependencies(
	[ExternalComponentDsPublicApiSymbol],
	(externalComponentApi: IExternalComponentDsPublicApi): FileChangedMiddleware => {
		return {
			onFileChanged(fileDescriptor) {
				const isFolder = fileDescriptor.directory
				const isFile = !fileDescriptor.directory

				if (isFolder && fileDescriptor.name === 'components') {
					externalComponentApi.reloadAllComponents()
				} else if (isFile && fileDescriptor.location.startsWith('/components')) {
					externalComponentApi.reloadComponentsLinkedToFile(fileDescriptor.location)
				}
			},
		}
	}
)
